export default "__VITE_ASSET__CwGqH7y3__"